import { render, staticRenderFns } from "./attachManage.vue?vue&type=template&id=34c88f7e"
import script from "./attachManage.vue?vue&type=script&lang=js"
export * from "./attachManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c88f7e')) {
      api.createRecord('34c88f7e', component.options)
    } else {
      api.reload('34c88f7e', component.options)
    }
    module.hot.accept("./attachManage.vue?vue&type=template&id=34c88f7e", function () {
      api.rerender('34c88f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/attach/attachManage.vue"
export default component.exports